import React from "react";

import AbbreviatedMillionNumberFormat from "../components/ui-building-blocks/numbers/AbbreviatedMillionNumberFormat";
import HelpIconButtonWithTooltipAndTypeformModal from "../components/typeform/HelpIconButtonWithTooltipAndTypeformModal";
import HelpIconButtonWithTooltip from "../components/ui-building-blocks/icons/HelpIconButtonWithTooltip";
import TypeformContent from "../components/typeform/TypeformContent";

class ResultsValuationsResults extends React.Component {
  getMarketValue(team_id) {
    if (team_id in this.props.valuationsResults.marketValue.data) {
      return this.props.valuationsResults.marketValue.data[team_id];
    }

    return 0;
  }

  getPriceToEarnings(team_id) {
    if (team_id in this.props.valuationsResults.pricetoEarnings.data) {
      return this.props.valuationsResults.pricetoEarnings.data[team_id].toFixed(
        2
      );
    }

    return (0).toFixed(2);
  }

  getPriceToSales(team_id) {
    if (team_id in this.props.valuationsResults.pricetoSales.data) {
      return this.props.valuationsResults.pricetoSales.data[team_id].toFixed(2);
    }

    return (0).toFixed(2);
  }

  getPriceToBook(team_id) {
    if (team_id in this.props.valuationsResults.pricetoBook.data) {
      return this.props.valuationsResults.pricetoBook.data[team_id].toFixed(2);
    }

    return (0).toFixed(2);
  }

  render() {
    return (
      <div className="container-analysis">
        <h3 className="semibold">
          Valuation Results
          <HelpIconButtonWithTooltip
            tooltipContent="This section compares your business’s value relative to your competitors on 3 different valuation approaches."
            category="Valuation Results"
          />
        </h3>
        <div className="panel-dashboard-white bg-light-gray p-15 mt-30">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>
                    <span />
                  </th>
                  {Object.keys(this.props.teams).map(team_id => {
                    let team_name = this.props.teams[team_id];
                    return (
                      <th key={team_id}>
                        <span>{team_name}</span>
                      </th>
                    );
                  })}
                </tr>
              </thead>
              <tbody>
                <tr className="text-center">
                  <th>
                    Market Cap
                    <HelpIconButtonWithTooltipAndTypeformModal
                      iconSize="xs"
                      {...TypeformContent.BUSINESS_VALUATION}
                    />
                  </th>
                  {Object.keys(this.props.teams).map(team_id => {
                    const marketValue = this.getMarketValue(team_id);
                    return (
                      <td key={team_id}>
                        <AbbreviatedMillionNumberFormat
                          value={marketValue}
                          prefix="$"
                        />
                      </td>
                    );
                  })}
                </tr>
                <tr className="text-center">
                  <th>
                    P/E
                    <HelpIconButtonWithTooltipAndTypeformModal
                      iconSize="xs"
                      {...TypeformContent.PRICE_EARNINGS_RATIO}
                    />
                  </th>
                  {Object.keys(this.props.teams).map(team_id => {
                    const priceToEarnings = this.getPriceToEarnings(team_id);
                    return (
                      <td key={team_id}>
                        {priceToEarnings < 0 ? "n/a" : `${priceToEarnings}x`}
                      </td>
                    );
                  })}
                </tr>
                <tr className="text-center">
                  <th>
                    P/S
                    <HelpIconButtonWithTooltipAndTypeformModal
                      iconSize="xs"
                      {...TypeformContent.PRICE_SALES_RATIO}
                    />
                  </th>
                  {Object.keys(this.props.teams).map(team_id => {
                    const priceToSales = this.getPriceToSales(team_id);
                    return (
                      <td key={team_id}>
                        {priceToSales < 0 ? "n/a" : `${priceToSales}x`}
                      </td>
                    );
                  })}
                </tr>
                <tr className="text-center">
                  <th>
                    P/B
                    <HelpIconButtonWithTooltipAndTypeformModal
                      iconSize="xs"
                      {...TypeformContent.PRICE_TO_BOOK_RATIO}
                    />
                  </th>
                  {Object.keys(this.props.teams).map(team_id => {
                    const priceToBook = this.getPriceToBook(team_id);
                    return (
                      <td key={team_id}>
                        {priceToBook < 0 ? "n/a" : `${priceToBook}x`}
                      </td>
                    );
                  })}
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}

export default ResultsValuationsResults;



// WEBPACK FOOTER //
// ./src/containers/ResultsValuationsResults.js